import { render, staticRenderFns } from "./ConfirmDetailsDialog.vue?vue&type=template&id=b3a5a5ec"
import script from "./ConfirmDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports